import { render, staticRenderFns } from "./insertAddress.vue?vue&type=template&id=5faffe66"
import script from "./insertAddress.vue?vue&type=script&lang=js"
export * from "./insertAddress.vue?vue&type=script&lang=js"
import style0 from "./insertAddress.vue?vue&type=style&index=0&id=5faffe66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports